













import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import VipTag from "@/api/vip/vipTag/index";
@Component
export default class TagSelect extends Vue {
  @Prop({
    type: Array,
    default: () => {
      return [];
    }
  })
  selectedItems!: string[];

  @Prop({
    type: Boolean,
    default: () => {
      return false;
    }
  })
  show!: false;

  showModal = false;
  data = [];
  selectTags = [];

  async mounted() {}

  @Watch("show")
  async modalShowChange(show) {
    this.showModal = !this.showModal;
    if (this.showModal) {
      await this.getTagList();
    }
  }

  async getTagList() {
    await VipTag.getAllTagList(false).then(res => {
      this.data = res.data.items;
      console.log(res.data.items);
      let copySelectItems = JSON.parse(JSON.stringify(this.selectedItems));
      let arr = res.data.items.filter(item => copySelectItems.indexOf(item.name) > -1)
      this.selectTags = arr.map(item => item.value)
    });
  }

  cancelFn() {
    this.showModal = false;
    this.selectTags = [];
  }

  ok() {
    let result = this.data.filter(t => this.selectTags.indexOf(t.value) > -1);
    this.$emit("on-change", this.selectTags, result);
    this.cancelFn();
  }
}
